import './_product-subscription-widget.scss';
import component from './product-subscription-widget';

export default component;
